import { FC, Fragment } from 'react';
import { Grid } from '@material-ui/core';
import { useProfileListCheckbox } from './useProfileListCheckbox';
import ProfileCheckBox from './ProfileCheckBox/ProfileCheckBox';
import { ProfileListCheckboxProps } from 'pages/MyLinks/types';

const ProfileListCheckbox: FC<ProfileListCheckboxProps> = ({
  profileLink,
  setSelectedPrimary,
  selectedPrimary,
  isPublished,
}) => {
  const { CheckBoxList, isRepresented, isUpdating, selectedBox } = useProfileListCheckbox(
    profileLink,
    selectedPrimary,
    setSelectedPrimary,
  );

  return (
    <Grid container>
      {CheckBoxList.map((check) =>
        isRepresented && (check?.name === 'Include my Email' || check?.name === 'Include my Phone Number') ? (
          <Fragment key={check?.name} />
        ) : (
          <Grid
            key={check?.name}
            item
            xs={isRepresented ? 12 : 6}
            lg={4}
            style={{ opacity: isPublished ? 1 : 0.2, paddingInline: '10px' }}
          >
            <ProfileCheckBox
              check={check}
              isUpdating={isUpdating}
              selectedBox={selectedBox || ''}
              profileLink={profileLink}
              selectedPrimary={selectedPrimary}
              isPublished={isPublished}
            />
          </Grid>
        ),
      )}
    </Grid>
  );
};

export default ProfileListCheckbox;
